import { Link } from 'react-router-dom';
import { Heart, ShoppingCart } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function ProductCard({ product, onAddToCart, onToggleWishlist, isWishlisted }) {
  return (
    <div className="group bg-white rounded-xl border border-border-custom overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-lg" data-testid={`product-card-${product.id}`}>
      <Link to={`/products/${product.id}`} className="block">
        <div className="relative aspect-square overflow-hidden bg-pale/30">
          <img
            src={(product.image_urls && product.image_urls.length > 0) ? product.image_urls[0] : product.image_url} alt={product.name}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=500&h=500&fit=crop'; }}
          />
          {product.is_featured && (
            <span className="absolute top-3 left-3 bg-rust text-cream text-xs font-body font-medium px-2.5 py-1 rounded-full">Featured</span>
          )}
          {product.wholesale_price && (
            <span className="absolute top-3 right-3 bg-amber text-white text-xs font-body font-medium px-2.5 py-1 rounded-full">Wholesale</span>
          )}
        </div>
      </Link>
      <div className="p-4">
        <p className="text-xs font-body text-light-brown uppercase tracking-wider mb-1">{product.category}</p>
        <Link to={`/products/${product.id}`}>
          <h3 className="font-body font-medium text-dark-brown text-sm mb-2 line-clamp-1 hover:text-rust transition-colors" data-testid={`product-name-${product.id}`}>
            {product.name}
          </h3>
        </Link>
        {product.review_count > 0 && (
          <div className="flex items-center gap-2 mb-1">
             <span className="bg-[#388E3C] text-white text-[11px] font-bold px-1.5 py-0.5 rounded flex items-center gap-0.5" style={{fontFamily: 'Roboto, sans-serif'}}>
                {product.average_rating?.toFixed(1)} 
                <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
             </span>
             <span className="text-[#878787] text-[13px] font-medium" style={{fontFamily: 'Roboto, sans-serif'}}>
               ({product.review_count.toLocaleString()})
             </span>
          </div>
        )}
        <div className="flex items-center justify-between mt-1">
          <div className="flex-1 min-w-0 flex items-baseline gap-2 flex-wrap">
            <span className="font-body font-bold text-[#212121] text-[17px]" style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: '-0.02em', fontFamily: 'Roboto, sans-serif' }} data-testid={`product-price-${product.id}`}>
              {'\u20B9'}{product.price.toLocaleString('en-IN')}
            </span>
            {product.mrp && product.mrp > product.price && (
              <>
                <span className="text-[#878787] text-[13px] line-through" style={{ fontVariantNumeric: 'tabular-nums', fontFamily: 'Roboto, sans-serif' }}>
                  {'\u20B9'}{product.mrp.toLocaleString('en-IN')}
                </span>
                <span className="text-[#388E3C] text-[13px] font-bold" style={{fontFamily: 'Roboto, sans-serif'}}>
                  {Math.round(((product.mrp - product.price) / product.mrp) * 100)}% off
                </span>
              </>
            )}
          </div>
          <div className="flex gap-1.5 shrink-0 ml-1">
            {onToggleWishlist && (
              <button onClick={(e) => { e.preventDefault(); onToggleWishlist(product.id); }}
                className={`p-2 rounded-full transition-all duration-300 ${isWishlisted ? 'bg-rust/10 text-rust' : 'bg-pale text-light-brown hover:text-rust hover:bg-rust/10'}`}
                data-testid={`wishlist-toggle-${product.id}`}>
                <Heart className={`w-4 h-4 ${isWishlisted ? 'fill-current' : ''}`} />
              </button>
            )}
            {onAddToCart && (
              <Button onClick={(e) => { e.preventDefault(); onAddToCart(product.id); }} size="sm"
                className="bg-rust hover:bg-rust/90 text-cream rounded-full h-9 w-9 p-0"
                data-testid={`add-to-cart-${product.id}`}>
                <ShoppingCart className="w-4 h-4" />
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
